import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * tailwind-merge is told about this project's custom theme so it merges
 * conflicting classes correctly:
 *  - text:  custom font-size names that aren't in the default scale
 *           (text-0, text-md, text-0_5xl, text-1_5xl)
 *  - color: the closed brand palette + the contextual accent + semantic tokens
 *  - shadow/spacing/font: the remaining custom tokens
 */
const twMergeCustom = extendTailwindMerge({
    extend: {
        theme: {
            font: ['sans'],
            text: ['0', 'md', '0_5xl', '1_5xl'],
            spacing: ['container'],
            shadow: ['submenu', 'nav'],
            color: [
                'transparent',
                'current',
                'white',
                'black',
                'purple',
                'lilac',
                'pink',
                'orange',
                'green',
                'blue',
                'red',
                'gray',
                'accent-color',
                'bg',
                'fg',
                'primary',
                'primary-fg',
                'muted-fg',
                'border',
            ],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMergeCustom(clsx(inputs));
}
